import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgDialog } from "@intelligems/ig-theme";
import { useDialog } from "@src/hooks/dialog";
import { removeKeyMetric } from "@src/store/slices/experienceMetrics/experienceMetrics";
import { selectedExperience } from "@src/store/slices/experiences";

export const RemoveArchivedKeyMetricWarning = () => {
  const dispatch = useDispatch();
  const dialog = useDialog("removeArchivedKeyMetric");
  const experience = useSelector(selectedExperience);
  const index = dialog.props?.index ?? 0;

  return (
    <IgDialog
      showDialog={dialog.isOpen}
      handleClose={dialog.close}
      dialogHeight={null}
      title={
        "Are you sure you want to remove this as a key metric from your experiment?"
      }
      subtitle={
        "Removing this key metric from your experiment will prevent you from re-adding it while the event is archived, as the test is currently live."
      }
      subtitleSx={{ marginBottom: "10px" }}
      yesButtonText={"Yes, remove this event"}
      handleYesClick={() => {
        dispatch(
          removeKeyMetric({
            indexToRemove: experience.status !== "pending" ? index + 1 : index,
          })
        );
        dialog.close();
      }}
    ></IgDialog>
  );
};
